import { THANK_YOU_TEXT } from 'consts/idv';
import { LANGS } from 'consts/global';

export const getIdvThankYouText = (requestType: string) =>
  THANK_YOU_TEXT[requestType] || THANK_YOU_TEXT.default;

export const sanitizeBase64 = (base64str = '') =>
  base64str.slice(base64str.indexOf(',') + 1);

export const getMimeType = (base64str = '') =>
  base64str ? base64str.slice(base64str.indexOf(':') + 1, base64str.indexOf(';')) : null;

export const parseSecuremeLang = (secureMeLang: string): string | undefined => {
  const langNoRegion = secureMeLang?.toLowerCase().slice(0, 2);
  return Object.keys(LANGS).find(key => key.startsWith(langNoRegion));
};
